import { useMsal } from '@azure/msal-react'
import { Box } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from '@stripe/react-connect-js'
import { useSessionInfo } from '../../contexts/SessionContext'
import { setStripeOnboardingComplete } from '../../data/organization.service'
import useStripeConnect from '../../hooks/useStripeConnect'

interface StripeOnboardingProps {
  onCompletion: () => void
  stripeConnectId: string | null
}

function StripeOnboarding(props: StripeOnboardingProps) {
  const { onCompletion, stripeConnectId } = props
  const stripeConnectInstance = useStripeConnect(stripeConnectId)
  const { instance } = useMsal()
  const { session } = useSessionInfo()

  const handleExit = async () => {
    if (!session?.organizationId) return

    try {
      await setStripeOnboardingComplete(session.organizationId, instance)
      onCompletion()
    } catch (error) {
      console.error('Error updating Stripe onboarding status:', error)
      notifications.show({
        title: 'Error',
        message: 'Failed to update Stripe onboarding status. Please try again.',
        color: 'red',
      })
    }
  }

  return (
    <Box h='100%' w='100%' maw={1080}>
      {stripeConnectInstance && (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectAccountOnboarding onExit={handleExit} />
        </ConnectComponentsProvider>
      )}
    </Box>
  )
}

export default StripeOnboarding
